<div class="banner">
    <div class="row">
        <div *ngIf="!renew && !bulkRenew"  class="col-4 ps-0 pb-5"><h1>Checkout</h1></div>
        <div *ngIf="bulkRenew && !renew" class="col-5 ps-0 pb-5"><h1>Bulk Renew Checkout</h1></div>
        <div *ngIf="!renew && !manualPayForMonthlyBilling && !bulkRenew"  class="col-4 mt-2"><p><small><b>All short codes on this page will be part of the same order. If you need to have the codes billed separately, start a new order for each.</b></small></p></div>
        <div *ngIf="bulkRenew && !renew "  class="col-4 mt-2"><p><small><b> If you pay for these renewals now, all short codes on this page will be part of the same order. If you choose to pay later, the short codes on this page will be billed as separate orders.</b></small></p></div>
        <div *ngIf="renew && !bulkRenew" class="col-4 ps-0 pb-5"><h1>Renew Checkout</h1></div>

    </div>
    <div *ngIf="!manualPayForMonthlyBilling && !bulkRenew" class="tab">
        <ul class="nav nav-tabs">
            <li><a [routerLink]="[{ outlets: { 'order-code-tab': ['cart'] } }]" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }" id="cart" >Cart</a></li>
            <li><a [routerLink]="[{ outlets: { 'order-code-tab': ['application'] } }]" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }" id="application" [class.disabled]="getDisableApplication() ? true : null" >Application</a></li>
            <li><a [routerLink]="[{ outlets: { 'order-code-tab': ['payment'] } }]" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }" id="payment" [class.disabled]="true" >Payment</a></li>
        </ul>
    </div>
    <div *ngIf="manualPayForMonthlyBilling && !bulkRenew" class="tab">
        <ul class="nav nav-tabs">
            <li><a [routerLink]="[{ outlets: { 'order-code-tab': ['payment'] } }]" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }" id="payment" [class.disabled]="true" >Payment</a></li>
        </ul>
    </div>
    <div *ngIf="bulkRenew  && !manualPayForMonthlyBilling" class="tab">
        <ul class="nav nav-tabs">
            <li><a [routerLink]="[{ outlets: { 'order-code-tab': ['cart'] } }]" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }" id="cart" >Cart</a></li>
            <li><a [routerLink]="[{ outlets: { 'order-code-tab': ['payment'] } }]" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }" id="payment" [class.disabled]="true" >Payment</a></li>
        </ul>
    </div>
 
</div>
<div class="tabcontent">
    <router-outlet name="order-code-tab"></router-outlet>
</div>
<p-confirmDialog key='leavecart' #leavecart width="425" [closable]="false" [blockScroll]="false" >
    <p-footer>
        <button i18n id="canReject" class="btn btn-secondary" (click)="leavecart.reject()">Stay on Page</button>
        <button i18n id="canAccept" class="btn btn-secondary" (click)="unSetKeepTheCode(); leavecart.accept()">Cancel Order and Leave Page</button>
        <button i18n id="canAccept2" class="btn btn-primary me-2" (click)="setKeepTheCode(); leavecart.accept();">Keep Codes and Leave Page</button>
    </p-footer>
</p-confirmDialog>
